import type { OrgChartApiService } from '../../services/org-chart-api.service';

/**
 * Give a position the roles `after`, given that it had `before`.
 *
 * One request per role added or taken away — the API has no call for the
 * whole set. Shared by the position's form and the panel behind its shield,
 * so the two save a selection the same way.
 */
export async function syncPositionRoles(
  api: Pick<OrgChartApiService, 'addPositionRole' | 'removePositionRole'>,
  positionId: string,
  before: readonly string[],
  after: readonly string[],
): Promise<void> {
  const beforeSet = new Set(before);
  const afterSet = new Set(after);
  for (const roleId of after) {
    if (!beforeSet.has(roleId)) await api.addPositionRole(positionId, roleId);
  }
  for (const roleId of before) {
    if (!afterSet.has(roleId)) await api.removePositionRole(positionId, roleId);
  }
}

/** Whether two selections hold the same roles, in whatever order. */
export function sameRoles(
  a: readonly string[],
  b: readonly string[],
): boolean {
  if (a.length !== b.length) return false;
  const set = new Set(a);
  return b.every((id) => set.has(id));
}
